import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import _ from "lodash";
import NoContentAdded, { NO_REVIEWER } from "NoContentAdded";
import Pagination from "react-js-pagination";
import { IMAGE_PATH, itemCount, COMMON_FAIL_MESSAGE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import Button from "react-bootstrap-button-loader";
import {
  fetchProposalStep,
  fetchReviewerList,
  addReviewer,
  checkProposalReviewer,
  fetchSingleProposal,
  editProposal,
  deleteReviewer,
  openAddReviewer,
} from "ProposalAction";
import LocaleStrings from "Languages";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import AddNewReviewer from "./add-reviewer";
import ReviewerCell from "../reviewercell";

class EditReviewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      selectedReviewers: [],
      allCheck: false,
      loading: false,
      disabled: true,
      distribution: "",
      saveButtonVisible: false,
    };
  }

  componentDidMount() {
    this.props.fetchReviewerList(this.props.session);

    var { selectedReviewers } = this.state;
    if (
      this.props.updateProposal &&
      this.props.updateProposal.reviewer_by_proposal_reviewer &&
      this.props.updateProposal.reviewer_by_proposal_reviewer.length > 0
    ) {
      let distribution = this.props.updateProposal.distribution;
      let saveButtonVisible = distribution == "manual" ? false : true;
      this.setState({ saveButtonVisible, distribution: distribution });

      _.map(this.props.updateProposal.reviewer_by_proposal_reviewer, (obj) => {
        var index = _.findIndex(selectedReviewers, function (sel) {
          return sel.appuserid === obj.appuserid;
        });

        if (index >= 0) {
          var newSelectedValues = _.filter(selectedReviewers, function (sel) {
            return sel.appuserid !== obj.appuserid;
          });
          this.checkMatchArray(newSelectedValues);
          this.setState({
            selectedReviewers: newSelectedValues,
            disabled: false,
          });
        } else {
          var selectedValues = { ...obj, checked: true };
          selectedReviewers = [...selectedReviewers, selectedValues];
          this.checkMatchArray(selectedReviewers);
          this.setState({ selectedReviewers, disabled: false });
        }
      });
    }
  }

  selectionCallback = (user) => {
    var { selectedReviewers } = this.state;
    var index = _.findIndex(selectedReviewers, function (sel) {
      return sel.appuserid === user.appuserid;
    });
    //console.log('user',user);

    //console.log('index',index);
    if (index >= 0) {
      var newSelectedValues = _.filter(selectedReviewers, function (sel) {
        return sel.appuserid !== user.appuserid;
      });
      this.checkMatchArray(newSelectedValues);
      this.setState({ selectedReviewers: newSelectedValues, disabled: false });
    } else {
      var selectedValues = { ...user, checked: true };
      selectedReviewers = [...selectedReviewers, selectedValues];
      this.checkMatchArray(selectedReviewers);
      this.setState({ selectedReviewers, disabled: false });
    }
  };

  checkMatchArray = (selectedValues) => {
    var reviewerList = this.props.appUserreviewerList.data;
    var newArray = [];
    _.map(reviewerList, (obj) => {
      var newSelectedValues = _.filter(selectedValues, function (sel) {
        return sel.appuserid === obj.appuserid;
      });
      if (newSelectedValues && newSelectedValues.length > 0) {
        newArray = [...newArray, newSelectedValues];
      }
    });

    // Check for all tickets selected or not according to that check or uncheck master check option
    if (newArray.length > 0 && newArray.length === reviewerList.length) {
      this.setState({ allCheck: true });
    } else {
      this.setState({ allCheck: false });
    }
  };

  renderReviewerList() {
    var { selectedReviewers } = this.state;
    var reviewerList = this.props.appUserreviewerList.data;
    var cells = [];

    _.map(reviewerList, (user, index) => {
      var selected = selectedReviewers.find(
        (obj) => obj.appuserid === user.appuserid
      );
      var checked = false;
      if (selected) {
        checked = selected.checked;
      }
      cells.push(
        <ReviewerCell
          key={user.appuserid}
          user={user}
          checked={checked}
          selectedreviewers={false}
          toggleSelection={this.selectionCallback}
          distribution={this.state.distribution}
        />
      );
    });
    return cells;
  }

  renderSelectedList() {
    var { selectedReviewers } = this.state;
    var cells = [];

    _.map(selectedReviewers, (user, index) => {
      var checked = false;
      cells.push(
        <ReviewerCell
          key={user.appuserid}
          user={user}
          checked={checked}
          selectedreviewers={true}
          removeFromSelected={this.selectionCallback}
        />
      );
    });
    return cells;
  }

  paginationCallback = (pageNumber) => {
    this.props.fetchReviewerList(
      this.props.session,
      pageNumber,
      0,
      (response) => {}
    );
    this.setState({ ...this.state, pageNumber });
  };

  userAdditionCallback = () => {
    this.paginationCallback(this.state.pageNumber);
  };

  onSubmitForm = (values) => {
    //console.log('values',values);

    if (values.proposalid) {
      let { selectedReviewers } = this.state;

      if (selectedReviewers.length == 0) {
        this.props.showError(LocaleStrings.proposal_wizard_reviewer_validation);
      } else {
        var requestBody = {};
        requestBody.proposalid = values.proposalid;
        requestBody.distribution_val =
          values.distribution == "random" ? values.distribution_val : 0;
        requestBody.distribution = values.distribution;

        let reviewerArr = [];

        _.map(selectedReviewers, (cur) => {
          let obj = {
            proposalidfk: values.proposalid,
            reviewerid: cur.appuserid,
            eventid: this.props.session.eventid,
          };
          reviewerArr.push(obj);
        });

        this.setState({ loading: true });

        this.props.deleteReviewer(
          this.props.session,
          requestBody.proposalid,
          (feedback) => {
            this.props.addReviewer(
              this.props.session,
              requestBody,
              reviewerArr,
              true,
              (response) => {
                //console.log('proposal',response);
                if (response.success === 0) {
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  if (this.props.editMode) {
                    this.props.fetchSingleProposal(
                      this.props.session,
                      requestBody.proposalid,
                      (response) => {
                        let proposalList = response.data;
                        this.props.editProposal(proposalList[0]);
                      }
                    );
                  } else {
                    this.props.checkProposalReviewer(this.props.session);
                  }

                  this.setState({ loading: false });
                  this.props.showSuccess(
                    LocaleStrings.proposal_reviewer_add_succesfully
                  );
                  this.props.fetchProposalStep("step_4");
                }
              }
            );
          }
        );
      }
    }
  };

  skipReviewerAdd = () => {
    this.props.fetchProposalStep("step_4");
  };

  changeDistribution = (e) => {
    let distribution = e.target.value;
    let saveButtonVisible = distribution == "manual" ? false : true;
    this.setState({ distribution, saveButtonVisible });
  };

  preventPress = (e) => {
    e.preventDefault();
  };

  renderFieldRadio(field) {
    return (
      <div>
        <label
          className="custom-container-radio liveqa-label"
          style={{ marginBottom: 5 }}
        >
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  renderFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12 m-0 mb-5";
    var inputClasses = "col-sm-3 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  addNewReviewerOpen = () => {
    this.props.openAddReviewer(true, "");
  };

  selectAllRecords = () => {
    var { selectedReviewers, allCheck } = this.state;
    var reviewerList = this.props.appUserreviewerList.data;
    var newSelectValue = [];
    var newSelectedValues = [];

    if (allCheck == false) {
      _.map(reviewerList, (obj) => {
        var checkUserExitOrNot = _.filter(selectedReviewers, function (sel) {
          return sel.appuserid === obj.appuserid;
        });

        //Check if value is not exist in selected values that add
        if (checkUserExitOrNot.length == 0) {
          newSelectValue = { ...obj, checked: true };
          selectedReviewers = [...selectedReviewers, newSelectValue];
        }
        this.checkMatchArray(selectedReviewers);
        this.setState({ selectedReviewers, disabled: false });
      });
    } else {
      var leftValue = selectedReviewers;
      _.map(reviewerList, (obj) => {
        newSelectedValues = _.filter(leftValue, function (sel) {
          return sel.appuserid !== obj.appuserid;
        });
        leftValue = newSelectedValues;

        this.checkMatchArray(leftValue);
        this.setState({ selectedReviewers: leftValue, disabled: false });
      });
    }
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      appUserreviewerList,
      updateProposal,
      initialValues,
    } = this.props;

    //console.log('appUserreviewerList',appUserreviewerList);
    var itemCount = 20;

    var { selectedReviewers, disabled } = this.state;
    //console.log('selectedReviewers',selectedReviewers);
    var allListLeft = { borderRight: "1px solid #e6edf3" };
    var allListRight = {};

    if (
      appUserreviewerList &&
      appUserreviewerList.data &&
      appUserreviewerList.data.length < 11 &&
      selectedReviewers.length > appUserreviewerList.data.length
    ) {
      allListLeft = {};
      allListRight = { borderLeft: "1px solid #e6edf3" };
    }

    return (
      <div className="row" style={{ marginLeft: "0px" }}>
        {this.state.distribution == "" ||
        this.state.distribution == "manual" ? (
          <div
            className="col-md-8 mb-15"
            style={{ marginLeft: "-15px", fontWeight: "bold" }}
          >
            {/* *You must need to publish once after updating the data */}
          </div>
        ) : (
          <div>
            {/* <div
              className="col-md-8 mb-15"
              style={{ marginLeft: "-15px", fontWeight: "bold" }}
            > */}
            {/* *You must need to publish once after updating the data */}
            {/* </div> */}
            <div style={{ display: "flex" }}>
              <div className="col-md-8 px-15">
                <div
                  className="nav-bar-subtitle-title"
                  style={{ marginTop: "10px" }}
                >
                  {/* {LocaleStrings.proposal_wizard_add_reviewer_heading} */}
                  Add Reviewers
                </div>
                <div
                  className="nav-bar-subtitle-desc"
                  style={{ marginTop: "10px" }}
                >
                  {LocaleStrings.proposal_wizard_add_reviewer_heading}
                  {/* Add Reviewers */}
                </div>
                {/* <hr></hr> */}
              </div>
              <div className="col-md-4 " style={{ textAlign: "center" }}>
                <button
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={this.addNewReviewerOpen}
                  style={{ marginLeft: "240px" }}
                >
                  <i className="glyphicon glyphicon-plus i-custom-m"></i>
                  {LocaleStrings.proposal_wizard_add_reviewer_button}
                </button>
                {this.props.addReviewerModal.showModal ? (
                  <AddNewReviewer
                    finishOperationsCallback={this.userAdditionCallback}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="row" style={{ padding: "30px" }}>
              <div className="col-md-6 reviewer-left-box">
                <div className="col-md-12 reviewer-List">
                  <div className="reviewer-list-text">
                    {LocaleStrings.proposal_wizard_reviewerlist}
                  </div>
                  {appUserreviewerList &&
                  appUserreviewerList.data &&
                  appUserreviewerList.data.length > 0 ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            <label className="checkcontainer">
                              <input
                                type="checkbox"
                                onChange={this.selectAllRecords}
                                checked={this.state.allCheck}
                              />
                              <span className="checkcheckmark" />
                            </label>
                          </th>
                          <th>{LocaleStrings.proposal_wizard_reviewer_name}</th>
                        </tr>
                      </thead>
                      <tbody>{this.renderReviewerList()}</tbody>
                    </table>
                  ) : (
                    <NoContentAdded contentType={NO_REVIEWER} />
                  )}

                  {appUserreviewerList &&
                  appUserreviewerList.count > itemCount ? (
                    <Pagination
                      activePage={this.state.pageNumber}
                      itemsCountPerPage={itemCount}
                      totalItemsCount={this.props.appUserreviewerList.count}
                      pageRangeDisplayed={5}
                      onChange={this.paginationCallback}
                    />
                  ) : null}
                </div>
              </div>

              <div className="col-md-6 reviewer-right-box">
                <div className="col-md-12 reviewer-List">
                  <div className="reviewer-list-text">
                    {LocaleStrings.proposal_wizard_selected_reviewerlist}
                  </div>
                  {selectedReviewers.length > 0 ? (
                    <table className="table scrollable-table">
                      {/* <thead>
                    <tr>
                      <th>
                        <span>
                          {LocaleStrings.tickets_ticket_table_list_ticket_name}
                        </span>
                        {selectedReviewers.length > 0 ? (
                          <span className="pull-right">
                            Total: {selectedReviewers.length}
                          </span>
                        ) : (
                          ""
                        )}
                      </th>
                    </tr>
                  </thead> */}
                      <tbody>
                        <div className="scroll-section">
                          {this.renderSelectedList()}
                        </div>
                      </tbody>
                    </table>
                  ) : (
                    <NoContentAdded contentType={NO_REVIEWER} />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <div className="col-md-12" style={{ marginTop: "30px" }}>
            <div className="form-group px-15">
              <div
                className="reviewer-distribution-text"
                style={{ padding: 0 }}
              >
                {LocaleStrings.proposal_wizard_reviewer_distribution_text}
                <span className="label-mandatory">*</span>
              </div>
              <div
                className="col-sm-12 reviewer-distribution-list"
                style={{ padding: "5px", display: "flex" }}
              >
                <Field
                  name="distribution"
                  label={
                    LocaleStrings.proposal_wizard_reviewer_distribution_circular_text
                  }
                  component={this.renderFieldRadio}
                  type="radio"
                  value="circular"
                  onChange={this.changeDistribution}
                />
                <div className="">
                  <i
                    className="fa fa-exclamation-circle addnewreview-tooltip"
                    style={{
                      marginLeft: "6px",
                      marginTop: 2,
                      cursor: "pointer",
                    }}
                    aria-hidden="true"
                  ></i>
                  <div className="addnewreview-tooltiptext">
                    {LocaleStrings.reviewer_distribution_circular}
                  </div>
                </div>

                {/* <OverlayTrigger
                  key={"circular"}
                  placement="top"
                  overlay={
                    <Tooltip id={"tooltip-circular"}>
                      {LocaleStrings.reviewer_distribution_circular}
                    </Tooltip>
                  }
                >
                  <span
                    className="glyphicon glyphicon-info-sign"
                    style={{ color: "#1665d8", paddingTop: 3 }}
                  ></span>
                </OverlayTrigger> */}
              </div>
              <div
                className="col-sm-12 reviewer-distribution-list"
                style={{ display: "flex", padding: "5px" }}
              >
                <Field
                  name="distribution"
                  label={
                    LocaleStrings.proposal_wizard_reviewer_distribution_random_text
                  }
                  component={this.renderFieldRadio}
                  type="radio"
                  value="random"
                  onChange={this.changeDistribution}
                />
                <div className="">
                  <i
                    className="fa fa-exclamation-circle addnewreview-tooltip"
                    style={{
                      marginLeft: "6px",
                      marginTop: 2,
                      cursor: "pointer",
                    }}
                    aria-hidden="true"
                  ></i>
                  <div className="addnewreview-tooltiptext">
                    {LocaleStrings.reviewer_distribution_random}
                  </div>
                </div>
                {/* <OverlayTrigger
                  key={"random"}
                  placement="top"
                  overlay={
                    <Tooltip id={"tooltip-random"}>
                      {LocaleStrings.reviewer_distribution_random}
                    </Tooltip>
                  }
                >
                  <span
                    className="glyphicon glyphicon-info-sign"
                    style={{ color: "#1665d8", paddingTop: 3 }}
                  ></span>
                </OverlayTrigger> */}
              </div>
              <div
                className="col-sm-12 reviewer-distribution-list"
                style={{ padding: "5px", display: "flex" }}
              >
                <Field
                  name="distribution"
                  label={
                    LocaleStrings.proposal_wizard_reviewer_distribution_manual_text
                  }
                  component={this.renderFieldRadio}
                  type="radio"
                  value="manual"
                  onChange={this.changeDistribution}
                />
                <div className="">
                  <i
                    className="fa fa-exclamation-circle addnewreview-tooltip"
                    style={{
                      marginLeft: "6px",
                      marginTop: 2,
                      cursor: "pointer",
                    }}
                    aria-hidden="true"
                  ></i>
                  <div className="addnewreview-tooltiptext">
                    {LocaleStrings.reviewer_distribution_manual}
                  </div>
                </div>
                {/* <OverlayTrigger
                  key={"manual"}
                  placement="top"
                  overlay={
                    <Tooltip id={"tooltip-manual"}>
                      {LocaleStrings.reviewer_distribution_manual}
                    </Tooltip>
                  }
                >
                  <span
                    className="glyphicon glyphicon-info-sign"
                    style={{ color: "#1665d8", paddingTop: 3 }}
                  ></span>
                </OverlayTrigger> */}
              </div>
            </div>
            {this.state.distribution == "random" ? (
              <div className="form-group px-15">
                <Field
                  name="distribution_val"
                  label={
                    LocaleStrings.proposal_wizard_reviewer_distribution_random_selected_text
                  }
                  placeholder={
                    LocaleStrings.proposal_wizard_reviewer_distribution_value_placeholder
                  }
                  type="number"
                  component={this.renderFieldText}
                  mandatory="true"
                  min="1"
                  onKeyPress={this.preventPress}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="col-md-12 px-15" style={{ marginTop: "30px" }}>
            {this.state.saveButtonVisible ? (
              <Button
                className="btn btn-custom-blue ml-10"
                bsStyle=""
                loading={this.state.loading}
                disabled={
                  initialValues && initialValues.proposalid
                    ? false
                    : pristine || invalid || submitting
                }
                type="submit"
              >
                {LocaleStrings.proposal_wizard_reviewer_save_button}
              </Button>
            ) : (
              ""
            )}
            <Button
              className="btn btn-custom-blue ml-10"
              bsStyle=""
              type="button"
              onClick={this.skipReviewerAdd}
            >
              {LocaleStrings.proposal_wizard_reviewer_skip_button}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('formName :: == ', state.formName);
  // console.log('oldKeys :: == ', state.formList);
  var initVals = {};

  if (state.updateProposal && state.updateProposal.proposalid) {
    initVals = state.updateProposal ? state.updateProposal : {};
  } else {
    initVals = { distribution_val: 1 };
  }

  return {
    session: state.session,
    appUserreviewerList: state.appUserreviewerList,
    initialValues: initVals,
    updateProposal: state.updateProposal,
    addReviewerModal: state.addReviewerModal,
    editMode: !_.isEmpty(state.updateProposal),
  };
}

function validate(values) {
  var errors = {};
  var distribution = values["distribution"];
  if (!distribution) {
    errors["formid"] = LocaleStrings.tickets_ticket_form_validation_required;
  }

  return errors;
}

export default connect(mapStateToProps, {
  fetchReviewerList,
  fetchProposalStep,
  showError,
  showSuccess,
  addReviewer,
  checkProposalReviewer,
  fetchSingleProposal,
  editProposal,
  deleteReviewer,
  openAddReviewer,
})(
  reduxForm({
    validate,
    form: "ReviewerForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EditReviewer)
);
